// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"123":"279d45d7","383":"722b99ca","498":"840b1982","557":"4e1daf05","641":"353ae594","887":"d3ac5510"}[chunkId] + ".js";
};